// PixMMO's hand-drawn pixel sprites, copied from the game
// (src/components/store/pixel.tsx, SPRITES). Each row is a string of palette
// keys; "." is transparent. Regenerate with scripts/sprites.mjs.

export const SPRITES = {
  gem: {
    rows: ['..1111..', '.132221.', '13322221', '12222241', '.122241.', '..1241..', '...11...'],
    palette: {
      1: '#3b0764',
      2: '#a855f7',
      3: '#f3e8ff',
      4: '#7e22ce'
    }
  },
  crown: {
    rows: ['3...3...3', '22.232.22', '222222222', '252242252', '444444444'],
    palette: {
      2: '#facc15',
      3: '#fef9c3',
      4: '#a16207',
      5: '#ef4444'
    }
  },
  star: {
    rows: ['...3...', '..323..', '2222222', '.22222.', '.22.22.', '2.....2'],
    palette: {
      2: '#fbbf24',
      3: '#fef3c7'
    }
  },
  bag: {
    rows: ['..1111..', '.1....1.', '11111111', '12222221', '12233221', '12222221', '11111111'],
    palette: {
      1: '#422006',
      2: '#d97706',
      3: '#fde68a'
    }
  },
  gift: {
    rows: ['..3..3..', '...33...', '11133111', '12233221', '11133111', '12233221', '12233221', '11133111'],
    palette: {
      1: '#0c4a6e',
      2: '#38bdf8',
      3: '#f472b6'
    }
  },
  sparkle: {
    rows: ['..1..', '..1..', '11111', '..1..', '..1..'],
    palette: {
      1: '#ffffff'
    }
  },
  brush: {
    rows: ['......11', '.....121', '....121.', '...121..', '..33....', '.343....', '344.....', '44......'],
    palette: {
      1: '#9d174d',
      2: '#f472b6',
      3: '#a16207',
      4: '#fbbf24'
    }
  },
  flame: {
    rows: ['...1....', '..11..1.', '..121.1.', '.12211..', '.12321.1', '1233321.', '1233321.', '.12221..'],
    palette: {
      1: '#9a3412',
      2: '#f97316',
      3: '#fde047'
    }
  },
  hammer: {
    rows: ['11111...', '12221...', '12221...', '11111...', '..131...', '..131...', '..131...', '..111...'],
    palette: {
      1: '#1c1917',
      2: '#a1a1aa',
      3: '#b45309'
    }
  },
  paw: {
    rows: ['....22...22....', '...2322.2322...', '...2222.2222...', '....11...11....', '.22.........22.', '2322.......2322', '2222..222..2222', '.11..23222..11.', '....2222222....', '...222222222...', '...222222222...', '...1111.1111...'],
    palette: {
      1: '#be185d',
      2: '#f472b6',
      3: '#fce7f3'
    }
  },
  sword: {
    rows: ['....11....', '...1221...', '...1221...', '...1221...', '...1221...', '...1221...', '.33333333.', '....44....', '....44....', '...5555...'],
    palette: {
      1: '#3f3f46',
      2: '#e4e4e7',
      3: '#ca8a04',
      4: '#78350f',
      5: '#facc15'
    }
  },
  backpack: {
    rows: ['...1111...', '..1....1..', '.12222221.', '1222222221', '1233333321', '1231111321', '1233333321', '1224444221', '1224444221', '.11111111.'],
    palette: {
      1: '#172554',
      2: '#3b82f6',
      3: '#93c5fd',
      4: '#1d4ed8'
    }
  },
  hero: {
    rows: ['...1111...', '..144441..', '.14444441.', '.14333341.', '.13533531.', '.13333331.', '..133331..', '..112211..', '.12266221.', '1222662221', '1222222221'],
    palette: {
      1: '#3b0764',
      2: '#a855f7',
      3: '#fed7aa',
      4: '#92400e',
      5: '#1c1917',
      6: '#facc15'
    }
  },
  map: {
    rows: ['1111111111', '1222334241', '1222333421', '1222334241', '1222433221', '1224333221', '1222333221', '1422333221', '1222333221', '1111111111'],
    palette: {
      1: '#1e3a8a',
      2: '#fef3c7',
      3: '#fde68a',
      4: '#ef4444'
    }
  },
  compass: {
    rows: ['..111111..', '.12222221.', '1222332221', '1222332221', '1223553221', '1224554221', '1222442221', '1222442221', '.12222221.', '..111111..'],
    palette: {
      1: '#064e3b',
      2: '#a7f3d0',
      3: '#ef4444',
      4: '#047857',
      5: '#fbbf24'
    }
  },
  house: {
    rows: ['....11....', '...1331...', '..133331..', '.13333331.', '1333333331', '.12222221.', '.12552441.', '.12552441.', '.12222441.', '1111111111'],
    palette: {
      1: '#451a03',
      2: '#f59e0b',
      3: '#b91c1c',
      4: '#78350f',
      5: '#fef3c7'
    }
  },
  trophy: {
    rows: ['1111111111', '1132222411', '1.132241.1', '1.132241.1', '.11322411.', '...1241...', '...1241...', '..111111..', '.12222241.', '.11111111.'],
    palette: {
      1: '#7c2d12',
      2: '#fbbf24',
      3: '#fef3c7',
      4: '#d97706'
    }
  },
  shield: {
    rows: ['1111111111', '1322222221', '1322442221', '1324444221', '1322442221', '.12244221.', '.12222221.', '..122221..', '...1221...', '....11....'],
    palette: {
      1: '#172554',
      2: '#3b82f6',
      3: '#93c5fd',
      4: '#facc15'
    }
  },
  coinbag: {
    rows: ['..11..11..', '...1111...', '...1221...', '..122221..', '.12222221.', '1222442221', '1224554221', '1222442221', '.12222221.', '..111111..'],
    palette: {
      1: '#422006',
      2: '#a16207',
      4: '#facc15',
      5: '#fef9c3'
    }
  },
  party: {
    rows: ['.11....11.', '1331..1331', '1331..1331', '.11....11.', '..........', '1221..1221', '1222112221', '1222112221', '1111111111'],
    palette: {
      1: '#172554',
      2: '#60a5fa',
      3: '#fcd34d'
    }
  },
  footprints: {
    rows: ['.11.......', '1221......', '1221...11.', '1221..1221', '.11...1221', '......1221', '.11....11.', '1221......', '.11....11.', '......1221', '.......11.'],
    palette: {
      1: '#064e3b',
      2: '#34d399'
    }
  },
  door: {
    rows: ['..111111..', '.12323231.', '1232323231', '1232323231', '1232323231', '1232323431', '1232323231', '1232323231', '1232323231', '1111111111'],
    palette: {
      1: '#450a0a',
      2: '#b91c1c',
      3: '#ef4444',
      4: '#fbbf24'
    }
  },
  globe: {
    rows: ['..1111..', '.122321.', '12223221', '13333331', '12232221', '12232221', '.123221.', '..1111..'],
    palette: {
      1: '#0c4a6e',
      2: '#38bdf8',
      3: '#bae6fd'
    }
  },
  android: {
    rows: ['.1.....1.', '..1...1..', '..22222..', '.2322232.', '.2222222.', '.........', '2.22222.2', '2.22222.2', '..2...2..'],
    palette: {
      1: '#86efac',
      2: '#4ade80',
      3: '#052e16'
    }
  },
  phone: {
    rows: ['111111', '122221', '133331', '133331', '133331', '133331', '133331', '122221', '124421', '111111'],
    palette: {
      1: '#27272a',
      2: '#71717a',
      3: '#7dd3fc',
      4: '#d4d4d8'
    }
  },
  monitor: {
    rows: ['1111111111', '1222222221', '1233333321', '1233333321', '1233333321', '1222222221', '1111111111', '....11....', '..111111..'],
    palette: {
      1: '#1e1b4b',
      2: '#6366f1',
      3: '#a5b4fc'
    }
  },
  quill: {
    rows: ['.......11', '......121', '.....1221', '....1221.', '...1221..', '..1221...', '.1331....', '1331.....', '44.......'],
    palette: {
      1: '#78350f',
      2: '#fef3c7',
      3: '#a16207',
      4: '#1c1917'
    }
  },
  cards: {
    rows: ['..11111111', '..12222221', '1111111121', '1233333121', '1234443121', '1234443121', '1233333121', '1235553111', '12333331..', '11111111..'],
    palette: {
      1: '#3b0764',
      2: '#a855f7',
      3: '#fef3c7',
      4: '#ef4444',
      5: '#a16207'
    }
  },
  stall: {
    rows: ['1111111111', '2323232323', '2323232323', '.4......4.', '.4.55.6.4.', '1111111111', '.7......7.', '.7......7.'],
    palette: {
      1: '#78350f',
      2: '#dc2626',
      3: '#fef3c7',
      4: '#a16207',
      5: '#facc15',
      6: '#34d399',
      7: '#451a03'
    }
  },
  coin: {
    rows: ['..1111..', '.123321.', '12322221', '13222241', '12222241', '12222441', '.124441.', '..1111..'],
    palette: {
      1: '#713f12',
      2: '#facc15',
      3: '#fef9c3',
      4: '#ca8a04'
    }
  },
  tag: {
    rows: ['11111...', '13221...', '122221..', '1222221.', '.1222221', '..122221', '...12221', '....1111'],
    palette: {
      1: '#78350f',
      2: '#f59e0b',
      3: '#fef3c7'
    }
  },
  gavel: {
    rows: ['..111....', '.12221...', '1222221..', '.1222221.', '..12221..', '...1.33..', '......33.', '.......33', '4444.....'],
    palette: {
      1: '#1e3a8a',
      2: '#60a5fa',
      3: '#a16207',
      4: '#78350f'
    }
  },
  chart: {
    rows: ['1.........', '1.......3.', '1......33.', '1..3..3...', '1.3.33....', '13........', '1.2..2..2.', '1.2.22.22.', '1111111111'],
    palette: {
      1: '#a1a1aa',
      2: '#34d399',
      3: '#fbbf24'
    }
  },
  swords: {
    rows: ['11......11', '121....121', '.121..121.', '..121121..', '...1221...', '...1221...', '..331133..', '.33.11.33.', '44......44', '44......44'],
    palette: {
      1: '#3f3f46',
      2: '#e4e4e7',
      3: '#ca8a04',
      4: '#78350f'
    }
  },
  skull: {
    rows: ['..111111..', '.12222221.', '1222222221', '1233223321', '1233223321', '1222112221', '.12222221.', '..121121..', '..111111..'],
    palette: {
      1: '#27272a',
      2: '#e7e5e4',
      3: '#dc2626'
    }
  },
  magnifier: {
    rows: ['..1111....', '.122221...', '12233221..', '12322221..', '12222221..', '12222221..', '.122221...', '..11113...', '......333.', '.......33.'],
    palette: {
      1: '#0c4a6e',
      2: '#7dd3fc',
      3: '#a16207'
    }
  },
  warflag: {
    rows: ['1.........', '12222223..', '12444423..', '12422423..', '12444423..', '12222223..', '1.33333...', '1.........', '1.........', '5.........'],
    palette: {
      1: '#78350f',
      2: '#dc2626',
      3: '#7f1d1d',
      4: '#facc15',
      5: '#451a03'
    }
  },
  bank: {
    rows: ['....11....', '..113311..', '.13355331.', '1111111111', '.2.2..2.2.', '.2.2..2.2.', '.2.2..2.2.', '.2.2..2.2.', '1111111111', '4444444444'],
    palette: {
      1: '#44403c',
      2: '#e7e5e4',
      3: '#a8a29e',
      4: '#78716c',
      5: '#facc15'
    }
  },
  vault: {
    rows: ['1111111111', '1222222221', '1233333321', '1234444321', '1234554321', '1234554361', '1234444321', '1233333321', '1222222221', '1111111111'],
    palette: {
      1: '#1c1917',
      2: '#52525b',
      3: '#a1a1aa',
      4: '#71717a',
      5: '#facc15',
      6: '#e4e4e7'
    }
  },
  uparrow: {
    rows: ['...1...', '..121..', '.12221.', '1122211', '..121..', '..121..', '..121..', '..111..'],
    palette: {
      1: '#7c2d12',
      2: '#fbbf24'
    }
  },
  gear: {
    rows: ['....22....', '.2.2222.2.', '..233332..', '.23311332.', '2231..1322', '2231..1322', '.23311332.', '..233332..', '.2.2222.2.', '....22....'],
    palette: {
      1: '#3f3f46',
      2: '#71717a',
      3: '#d4d4d8'
    }
  },
  lock: {
    rows: ['..4444..', '.4....4.', '.4....4.', '11111111', '12222221', '12233221', '12233221', '12222221', '11111111'],
    palette: {
      1: '#713f12',
      2: '#facc15',
      3: '#422006',
      4: '#a1a1aa'
    }
  },
  bell: {
    rows: ['....1....', '...121...', '..12221..', '..13221..', '.1322221.', '.1322221.', '122222221', '111111111', '...141...'],
    palette: {
      1: '#713f12',
      2: '#fbbf24',
      3: '#fef3c7',
      4: '#a16207'
    }
  },
  envelope: {
    rows: ['1111111111', '1122222211', '1212222121', '1221221221', '1222112221', '1222222221', '1111111111'],
    palette: {
      1: '#0c4a6e',
      2: '#e0f2fe'
    }
  },
  speaker: {
    rows: ['....1.....', '...121..3.', '111221.3..', '122221.3.3', '122221.3.3', '111221.3..', '...121..3.', '....1.....'],
    palette: {
      1: '#27272a',
      2: '#a1a1aa',
      3: '#34d399'
    }
  }
};
flarum.reg.add('soup-97-pixmmo-pixelui', 'common/sprites', { SPRITES: SPRITES, });